var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLabArmPrimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80294 6.214C8.66334 6.07439 8.48553 5.97922 8.29194 5.9405L7.09994 5.702C6.44576 5.57118 5.76663 5.66214 5.16994 5.9605L5.01094 6.0395C4.41424 6.33786 3.73512 6.42882 3.08094 6.298L2.11394 6.105C1.95254 6.07276 1.78567 6.08085 1.62815 6.12856C1.47063 6.17627 1.32732 6.26212 1.21094 6.3785M3.08894 0.5H7.08894L6.58894 1V3.586C6.58899 3.85119 6.69439 4.10551 6.88194 4.293L9.38194 6.793C10.0119 7.423 9.56544 8.5 8.67444 8.5H1.50294C0.611937 8.5 0.165937 7.423 0.795937 6.793L3.29594 4.293C3.48349 4.10551 3.58888 3.85119 3.58894 3.586V1L3.08894 0.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLabArmPrimer);
export default __webpack_public_path__ + "static/media/icLabArmPrimer.3a10e542eeb559c240c5413584e0c9dc.svg";
export { ForwardRef as ReactComponent };